import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = (payload) =>
    axios.post(`${API}/leads`, payload).then((r) => r.data);
